module.exports = __webpack_public_path__ + "img/stracraft.5a9d6794.jpg";